import React from 'react'
import Topsec from '../../Component/Privacy/Topsec'
import Content from '../../Component/Privacy/Content'
import Seo from '../../Component/Seo'

function Privacy() {
  return (
    <div>
      <Seo
        title='Privacy Policy | Halal Wealth'
        description='Review how Halal Wealth collects, uses, and protects your personal data across savings, investments, asset financing, and support interactions.'
        pathname='/privacy'
      />
      <Topsec/>
      <Content/>
    </div>
  )
}

export default Privacy
